// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"CompanyInfoForm_submitBtn__1jfxU","submitWrapper":"CompanyInfoForm_submitWrapper__1vFGB","formItem":"CompanyInfoForm_formItem__3iIgk"};